var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" You should not be here ")])}
var staticRenderFns = []

export { render, staticRenderFns }